import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxNumber',
  standalone: false,
})
export class MaxNumberPipe implements PipeTransform {

  transform(value: number | null | undefined, max: number): string {
    if (value == null) return '0';

    return value > max ? `+${max}` : value.toString();
  }
}
